import axios from 'axios'
import qs from 'qs'
import { getToken } from '@/utils/storage'
import store from '@/store'
import router from '@/router'

const api = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || '/api/v1',
  timeout: 30000
})

// Request interceptor: attach Bearer token
api.interceptors.request.use(config => {
  const token = getToken()
  if (token) {
    config.headers.Authorization = 'Bearer ' + token
  }
  return config
})

// Response interceptor: handle errors
api.interceptors.response.use(
  response => response.data,
  error => {
    const status = error.response ? error.response.status : null
    if (status === 401 || status === 403) {
      // logout action handles redirect — don't call router.replace here
      store.dispatch('auth/logout')
      // Suppress the error — user is already redirected
      return Promise.reject({ _authRedirect: true })
    }
    return Promise.reject(error.response ? error.response.data : error)
  }
)

export function postForm(url, data, headers = {}) {
  return api.post(url, qs.stringify(data), {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded', ...headers }
  })
}

export default api
